import { Basic } from "../basic.ts";
import { DragElement } from "../../lib/drag.js"
import { ItemHistorySubscription } from "../../observer/ItemHistorySubscription.js"
import { toBool } from "../../lib/utils.js";
import { ServerAdapterBase } from "../../observer/ServerAdapterBase.js";
import { ItemSubscription } from "../../observer/ItemSubscription.js";


/**
 * @class MSPlayHistory
 * @extends Basic
 * @classdesc Управление проигрыванием истории
 * */

class Queue {

    constructor() {
        this.queue = []
    }

    popFront() {
        if (!this.queue.length) return null
        return this.queue.shift()
    }

    front() {
        return this.queue[0]
    }

    pushBack(item) {
        this.queue.push(item)
    }

}

export class MSPlayHistory extends Basic {

    static get observedAttributes() {
        return super.observedAttributes.concat([
            'title',
            'dragable',
            'isControlVisible',
            'speed',
            'frameFrequency',
            'step',
            'isStarted'
        ]);
    }

    constructor() {
        super();
        console.log("CONSTRUCtor");
        const shadowRoot = this.attachShadow({ mode: 'open' });
        shadowRoot.innerHTML = `<div class="container">
                                    <div id="openControlButton" style="height:100%;width:100%;position:absolute; background:white">
                                        <img src="./controls/playhistory/History_player_mode-01.svg" style="width:100%;height:100%; position: absolute; top: 0; right: 0; bottom: 0; left: 0; margin: auto;"/>
                                    </div>
                                </div>`
            ;

        this._isControlVisible = false;
        this.style.userSelect = 'none';
        this.style.display = 'flex';
        this.style.overflow = 'hidden'
        this.style.boxSizing = 'border-box';
        this.sw = new ItemHistorySubscription("playhistory_" + this.id);

        this._main = shadowRoot.querySelector('div');
        this.addEventListener('click', this._click.bind(this));
        this._speed = 1.0;
        this._frameFrequency = 1;
        this._step = 100000000;
        this._isStarted = false;
        this._control = null;
        this._startTimer = 1618829507570;
        this._endTimer = 1621411690129;
        this._nowTimer = 1618829507570;
        this.intervalId = null;
        this.intervalIndex = -1;
        this.asyncIntervals = [];
        this.prevSequenceNumber = null;
        this.archivedItemsById = new Map();
        this.queue = new Queue();
        this.itemsQueues = new Map();
        this.linkUpInterval = 0;
        this.queuesListenerInterval = 0;
    }
    _click(e) {
        console.log(this)

        //document.querySelector("ms-playhistory").setAttribute("style", "color: blue; border-radius: 50%;")

        if (!this._isControlVisible) {

            this.setAttribute("style", this.getAttribute("style") + "color: blue;")

            this._control = document.createElement('div');
            this._control.innerHTML = `
                            <style>
                                .title {
                                    height:50;
                                    background: ${this.isStarted ? 'red' : 'grey'};
                                }

                                .settings {
                                    padding-top: 10;
                                    display: flex;
                                   
                                }

                                .options {
                                    display:flex;
                                    padding: 0;
                                    margin: 0;
                                    list-style: none;

                                    &__item {
                                        & + & {
                                            margin-left: 20;
                                        }   
                                    }
                                }

                                .intervail-optons {
                                    
                                    margin-left: auto;
                                    margin-right: 2%;

                                }

                                .step-speed-options {
                                    
                                    margin-left: auto;
                                    margin-right: 2%;

                                }

                                .play-options {
                                    padding-top: 10;
                                    display: flex;
                                    margin-left: 10%;
                                }
                                
                                .speed {
                                    color: gray;
                                    margin-left: 10;
                                }

                                .frame-frequency {
                                    color: gray;
                                    margin-left: 20;
                                }

                                .step {
                                    color: gray;
                                    margin-left: 20;
                                }

                                .input {
                                    cursor:pointer;
                                    height:100%;
                                    width:100%;
                                    opacity: 0;
                                    margin: 0;
                                    padding: 0;
                                }

                                .slider {
                                    list-style: none;
                                    display:flex;
                                    padding: 0;
                                    margin-left: 20;
                                    margin-right: 20;
                                }

                                .button-start {
                                    background: ${this.isStarted ? 'red' : 'grey'}; 
                                    heigh: 30px;
                                    width: 30px;
                                    margin-left: auto;
                                    margin-right: 5%;
                                    border-radius: 100%;
                                }

                                .play-items {
                                    display:flex;
                                    padding: 0;
                                    margin: 0;
                                    list-style: none;
                                    margin-left: auto;
                                    margin-right: 2%;
                                }
                                
                            </style>

                            <div class="container" style="left:${(+this.getAttribute('x')) + (+this.getAttribute('width'))};top:${this.getAttribute('y')};height:200;width:600; border: 1px solid black; position: absolute;" id="popup">
                                
                                <header class="title" id="title" style="background: ${this.isStarted ? 'red' : 'grey'};">
                                    <text stile="margin: auto; position: absolute;"></text>
                                    <button id="close" style="display:block; position: absolute;right: 2%; top:5%">X</button>
                                </header> 

                                <section class="settings">
                                    <ul class="options">
                                        <li class="speed">
                                            <section><text>Скорость</text></section>
                                            <section><text>${this.speed}</text></section>
                                        </li>
                                        <li class="frame-frequency">
                                            <section><text>Частота кадров</text></section>
                                            <section><text>${this.frameFrequency}</text></section>
                                        </li>
                                        <li class="step">
                                            <section><text>Шаг просмотра</text></section>
                                            <section><text>${this.step}</text></section>
                                        </li>
                                    </ul>
                                    <ul class="play-items">
                                        <li class="step-speed-options" id="stepSpeedOptions">
                                            <img src="./controls/playhistory/Step_speed_options-01.svg" style="heigh: 40px; width: 40px;" id="stepSpeedOptionsImg"/>
                                        </li>
                                        <li class="intervail-optons">
                                            <img src="./controls/playhistory/Interval_options-01.svg" style="heigh: 40px; width: 40px"/>
                                        </li>
                                    </ul>
                                </section>

                                <section>
                                    <div class="slider" id="sliderfill">
                                        <input id="customrange" type="range" list="tickmarks" min="${this._startTimer}" max="${this.endTimer}" value="${this.nowTimer}", style="width: 100%;"">
                                        <div id="fill" style="display:none; bottom:0; left:0; position:absolute; pointer-events:none; box-sizing: border-box;"></div>
                                        <div id='stc' style='position:absolute; pointer-events:none; height:100%; width:100%;'>
                                            <div id="sliderthumb" style='position:absolute; pointer-events:none; box-sizing: border-box;'></div>
                                        </div>
                                    </div>
                                </section>

                                <section class="play-options">
                                    <ul class="options">
                                        <li class="step-speed-options">
                                            <img src="./controls/playhistory/Left_step-01.svg" style="heigh: 25px; width: 25px;"/>
                                        </li>
                                        <li class="intervail-optons">
                                            <img src="./controls/playhistory/Left_slide_show-01.svg" style="heigh: 25px; width: 25px"/>
                                        </li>
                                        <li class="step-speed-options">
                                            <img src="./controls/playhistory/Left_play-01.svg" style="heigh: 25px; width: 25px;"/>
                                        </li>
                                        <li class="intervail-optons">
                                            <img src="./controls/playhistory/Stop-01.svg" style="heigh: 25px; width: 25px"/>
                                        </li>
                                        <li class="step-speed-options" id="rightPlay">
                                            <img src="./controls/playhistory/Right_play-01.svg" style="heigh: 25px; width: 25px;"/>
                                        </li>
                                        <li class="intervail-optons">
                                            <img src="./controls/playhistory/Right_slide_show-01.svg" style="heigh: 25px; width: 25px"/>
                                        </li>
                                        
                                        <li class="intervail-optons">
                                            <img src="./controls/playhistory/Right_step-01.svg" style="heigh: 25px; width: 25px"/>
                                        </li>
                                    </ul>

                                    <div class="button-start" id="start">
                                        <img src="./controls/playhistory/Right_play-01.svg"/>
                                    </div>
                                </section>
                            </div>`


            this._control.querySelector("#rightPlay").onclick = e => { this._stopWatchingReal() }
            this._control.querySelector('#close').onclick = e => { this._closeControl(); }
            this._control.querySelector('#start').onclick = e => { this._start(); }
            this._control.querySelector('#customrange').onchange = e => {
                this.nowTimer = e.target.value;
                this._control.querySelector("#customrange").setAttribute("value", `${this.nowTimer}`); console.log(e.target.value);
            }

            this._control.querySelector('#stepSpeedOptions').onclick = e => { this._openStepSpeedOptions(e) }

            this.parentNode.appendChild(this._control);
            this._title = document.getElementById('title');
            this._popup = document.getElementById('popup');

            // this._control = div;

            this._dnd = new DragElement(this._popup, this._title, { controlPosition: this._boundsrestricted, scale: this._scale || 1 });
            this._dnd.setDragZone(this._title);
            this._dnd.option.controlPosition = true;
            this._turnVisible();
        } else {
            this._closeControl()
        }
    }

    get isStarted() {
        return this._isStarted;
    }

    set isStarted(value) {
        this._isStarted = toBool(value);
        let title = this._control.querySelector("#title");
        let buttonStart = this._control.querySelector("#start");
        title.setAttribute("style", `background: ${this.isStarted ? "red" : "grey"};`);
        buttonStart.setAttribute("style", `background: ${this.isStarted ? "red" : "grey"};`);
    }

    get speed() {
        return this._speed;
    }

    set speed(value) {
        this._speed = value;
    }

    get frameFrequency() {
        return this._frameFrequency;
    }

    set frameFrequency(value) {
        this._frameFrequency = value;
    }

    get step() {
        return this._step;
    }

    set step(value) {
        this._step = value;
    }

    get title() {
        return this._title ? this._title : this.getAttribute("elname");
    }

    set title(value) {
        this._title = value;
    }

    get dragable() {
        return this._dragable;
    }
    set dragable(value) {
        this._dragable = value;
        if (this._dragable) {
            if (!this._dnd && this._popup) {
                if (this._showtitle) {
                    this._dnd = new DragElement(this._popup, this._title, { controlPosition: this._boundsrestricted, scale: this._scale || 1 });
                } else {
                    this._dnd = new DragElement(this._popup, this._popup, { controlPosition: this._boundsrestricted, scale: this._scale || 1 });
                }
            }
        }
    }

    get isControlVisible() {
        return this._isControlVisible;
    }

    set isControlVisible(value) {
        this._isControlVisible = value;
    }

    get startTimer() {
        return this._startTimer;
    }

    set startTimer(value) {
        this._startTimer = value;
    }


    get endTimer() {
        return this._endTimer;
    }

    set endTimer(value) {
        this._endTimer = value;
    }


    get nowTimer() {
        console.log(this._nowTimer, this.intervalId)
        return this._nowTimer;
    }

    set nowTimer(value) {
        if (value > this.endTimer) {
            if (this.intervalId) {
                clearInterval(this.intervalId);
                return;
            }
        }
        this._nowTimer = value;
        let range = this._control.querySelector("#customrange");
        range.setAttribute("value", `${this.nowTimer}`);
    }

    _openStepSpeedOptions(e) {
        console.log(e);

        let div = document.createElement('div');

        div.innerHTML = `
                        <style>
                            .step-speed-container {
                                height:500;
                                width:100;
                                background: black;
                                left: ${(+this.getAttribute('x')) + (+this.getAttribute('width')) + 300};
                                top: ${e.y + 100};
                                position: relative;
                            }
                        </style>

                        <div class="container">
                                <header class="step-speed-container"    >
                                </header> 
                        </div>
                        `
        console.log(div);
        if (this._control) {
            console.log("ASFSAF")
            this._control.appendChild(div);
        }
    }

    _turnVisible() {
        ''
        this._isControlVisible = !this._isControlVisible;
    }

    _closeControl() {
        if (this._dnd) {
            this._dnd.dispose();
            delete this._dnd;
        }
        var el = document.getElementById('popup');
        if (el) {
            el.remove()
            this._turnVisible()
        }
    }

    attributeChangedCallback(attrName, oldVal, newVal) {
        // if (attrName === 'ispressed') {
        //     if (newVal == true && !this._pressBtn && !this.isfixed) {
        //         return;
        //     }
        // }
        // if (attrName === 'ispressed' && !this._interaction) {
        //     if (this._lockLink) {
        //         this[attrName] = newVal
        //         return;
        //     }
        // }
        if (oldVal != newVal) {
            this[attrName] = newVal;
            if (this.prop_link[attrName]) {
                this.prop_link[attrName](
                    this.pId ? this.pId + '/' + this.id : this.id,
                    this.Links[attrName],
                    newVal,
                    attrName,
                    this.ItemIndex,
                    null,
                    this._lockLink
                );
            }
        }
    }

    async _resubscribe() {
        //?ItemSubscription.DeleteMonitoredDataItems([items]);

        //ItemHistorySubscription.CreateDataSubscription();
    }



    async _stop() {
        if (this.intervalId) {
            console.log("CLEAR INERVAL", this.intervalId);
            clearInterval(this.intervalId);
        }
        this.clearAsyncInterval(this.intervalIndex)

        if (this.queuesListenerInterval) clearInterval(this.queuesListenerInterval);

        $sw.ItemSubscription.ItemsContainer.forEach((el) => $sw.ItemSubscription.Observer[el.clientHandle].isBlocked = false);
    }

    _stopWatchingReal() {
        $sw.ItemSubscription.ItemsContainer.forEach((el) => { elms.push(el); $sw.ItemSubscription.Observer[el.clientHandle].isBlocked = true });
    }

    async _start() {

        this.SetParameter('isStarted', !this.isStarted);
        console.log(this.isStarted);

        let q = new Queue();

        if (!this.isStarted) {
            this._stop();
            return;
        }

        this.intervalIndex++;
        console.log("TIMER", +this._control.querySelector("#customrange").getAttribute("value"))

        if (this.isStarted) {
            this.nowTimer = +this._control.querySelector("#customrange").getAttribute("value");
            this.intervalId = setInterval(() => {
                this.nowTimer = this.nowTimer + this._step;
            }, 1000)
        }

        let elms = []
        $sw.ItemSubscription.ItemsContainer.forEach((el) => { elms.push(el); $sw.ItemSubscription.Observer[el.clientHandle].isBlocked = true });
        console.log(elms)

        //Создание новой подписки на проирывание истории
        const sub = await this.sw.CreateDataSubscription();
        const arItems = await this.sw.GetArchiveItems(elms, sub.subscriptionId);
        const arItemsIDs = arItems.items.map(item => item.archiveItemId);
        for (let i = 0; i < arItems.items.length; ++i) {
            this.archivedItemsById.set(arItemsIDs[i], arItems.items[i]);
        }

        console.log(this.archivedItemsById)


        await this.sw.AddSubscriptionItem(arItemsIDs, sub.subscriptionId);
        await this.sw.RunPlayerSubscription(this.startTimer, this.endTimer, this.speed, sub.subscriptionId);


        this.setAsyncInterval(async () => {
            const data = await this.sw.PlayerPublishData(sub.subscriptionId, this.prevSequenceNumber)
            console.log("DATA", data)
            if (data.data) {
                for (let i = 0; i < data.data.length; ++i) {
                    if (!this.itemsQueues.get(i)) this.itemsQueues.set(i, new Queue());
                    for (let j = 0; j < data.data[i].values.length; ++j) {
                        this.itemsQueues.get(i).pushBack(data.data[i].values[j]);
                    }
                }
                console.log("MAAAAAP", this.itemsQueues)
            }
        }, 2000)

        this.queuesListenerInterval = setInterval(() => {
            for (var key of this.itemsQueues.keys()) {
                if (!this.itemsQueues.get(key)) continue;
                if (this.itemsQueues.get(key).front()[0] < this.nowTimer) {
                    $sw.ItemSubscription.Observer[elms[key].clientHandle].isBlocked = false
                    this.sw.LinkUp({ clientHandle: elms[key].clientHandle, value: this.itemsQueues.get(key).popFront()[1] })
                    $sw.ItemSubscription.Observer[elms[key].clientHandle].isBlocked = true
                }
            }
        }, 500)
    }

    runAsyncInterval = async (cb, interval, intervalIndex) => {
        await cb();
        if (this.asyncIntervals[intervalIndex]) {
            setTimeout(() => this.runAsyncInterval(cb, interval, intervalIndex), interval);
        }
    };

    setAsyncInterval = (cb, interval) => {
        if (cb && typeof cb === "function") {
            const intervalIndex = this.asyncIntervals.length;
            this.asyncIntervals.push(true);
            this.runAsyncInterval(cb, interval, intervalIndex);
            return intervalIndex;
        }
    };

    clearAsyncInterval = (intervalIndex) => {
        this.asyncIntervals[intervalIndex] = false;
    };
}